import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as authAction from "../../../AxiosRtk/Auth";
import * as miscActions from "../../../AxiosRtk/Miscellaneous";
import validator from "validator";
import { isEmpty } from "lodash";
import { AlertModal } from "../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../setup/alert/iconTypes";
import { securityFilter } from "../../../../../utils/securityFilter";
import useCrypto from "../../../../customHooks/crypto";
import { isSpecialCharContains } from "../../../../../utils/specialCharCheck";
import { Link, useHistory } from "react-router-dom";
import SocialLogin from "../SocialAuth/SocialLogin";
import AuthTermsService from "../../../../shared/Components/AuthTermsService";
import useLangTranslation from "../../../../customHooks/languageProvider";
import Loader from "../../../../../setup/Loader/LoaderIndicator";
import SignUpSuccess from "./SignUpSuccess";
import { setSession } from "../../../../../utils/session";

const Signup = () => {
  const history = useHistory();
  const { getLangTranslation } = useLangTranslation();
  const { encryptRequest, decryptRequest } = useCrypto();
  const [loader, setLoader] = useState(false);
  const [defaultCountry, setDefaultCountry] = useState(null);


  const [inputFields, setInputFields] = useState([
    {
      type: "text",
      name: "name",
      labelText: "SIGNUP_NAME",
      id: "name",
      placeholder: "SIGNUP_NAME",
      labelValue: "name",
      value: "",
      error: "",
      errorField: "SIGN_UP_NAME_IS_REQUIRED_ERR",
      errFieldValue: "Name is required",
    },
    {
      type: "text",
      name: "email",
      labelText: "SIGNUP_EMAIL",
      id: "email",
      placeholder: "SIGNUP_EMAIL",
      labelValue: "email",
      value: "",
      error: "",
      errorField: "SIGN_UP_EMAIL_IS_REQUIRED_ERR",
      errFieldValue: "Email is required",
    },
    {
      type: "select",
      name: "country",
      labelText: "SIGNUP_COUNTRY",
      id: "country",
      placeholder: "SIGNUP_COUNTRY",
      labelValue: "Country",
      value: "",
      error: "",
      errorField: "Country_is_required",
      errFieldValue: "Country is required",
    },
    {
      type: "password",
      name: "password",
      labelText: "SIGNUP_PASSWORD",
      id: "password",
      placeholder: "SIGNUP_PASSWORD",
      labelValue: "password",
      value: "",
      error: "",
      displayPassword: false,
      errorField: "PASSWORD_IS_REQUIRED",
      errFieldValue: "Password is required",
    },
    {
      type: "password",
      name: "confirmPassword",
      labelText: "SIGNUP_CONFIRM_PASSWORD",
      labelValue: "Confirm password",
      id: "confirmPassword",
      placeholder: "SIGNUP_CONFIRM_PASSWORD",
      value: "",
      error: "",
      displayPassword: false,
      errorField: "CONFIRM_PWD_REQUIRED_ERR",
      errFieldValue: "Confirm password is required",
    },
    {
      type: "accordian",
      name: "referralCode",
      labelText: "SIGNUP_REFERRAL_CODE",
      labelValue: "Referral code",
      id: "referralCode",
      placeholder: "SIGNUP_ENTER_REFERRAL_CODE",
      placeholderValue: "Enter Referral code",
      value: "",
      error: "",
      errorField: "",
      errFieldValue: "",
    },
    {
      type: "checkbox",
      name: "termsCondition",
      labelText: "",
      id: "termsCondition",
      placeholder: "",
      value: false,
      error: "",
      errorField: "TERMS_AND_CONDITIONS_ERR",
      errFieldValue: "Please agree Terms of Service and Privacy Policy",
      dropdownValue: false,
    },
  ]);

  const [socialSignInData, setSocialSignInData] = useState(null);

  function handleInputChange(e) {
    const { name, value, checked } = e.target;
    const tempInputFields = [...inputFields];

    for (let i = 0; i < tempInputFields.length; i++) {
      if (tempInputFields[i]["name"] === name) {
        tempInputFields[i]["value"] =
          name !== "termsCondition" ? value : checked;
        tempInputFields[i]["error"] = "";
        break;
      }
    }

    setInputFields(tempInputFields);
  }

  const dispatch = useDispatch();
  const { getMyIPAddress, getCountryByIp } = miscActions;

  const { signup, login, setSignUpSuccessData, removeItem } = authAction;

  const { countryList, timezoneIdList } = useSelector(({ misc }) => misc);

  const { signUpSuccessData } = useSelector(({ auth }) => auth);

  // Fetching country list
  useEffect(() => {
    getPublicIp0();
  }, [dispatch]);

  useEffect(() => {
    if (defaultCountry) {
      const tempInputFieldData = [...inputFields];
      tempInputFieldData[2]["value"] = defaultCountry?.CountryID;
      setInputFields(tempInputFieldData);
    }
  }, [defaultCountry]);

  function formValidate() {
    const tempInputFields = [...inputFields];
    let flag = true;
    tempInputFields?.forEach((item, index) => {
      if (item?.name === "country") {
        return;
      }

      if (
        isEmpty(item?.value) &&
        item?.name !== "termsCondition" &&
        item?.name !== "referralCode"
      ) {
        tempInputFields[index]["error"] = item?.errorField;
        flag = false;
      } else if (!item?.value && item?.name === "termsCondition") {
        tempInputFields[index]["error"] = item?.errorField;
        flag = false;
      }

      //Check for special characters in name
      if (
        item?.name === "name" &&
        item?.value &&
        isSpecialCharContains(item?.value)
      ) {
        tempInputFields[index]["error"] = "SPECIAL_CHAR_NOT_ALLOWED_ERR";
        tempInputFields[index]["errFieldValue"] =
          "Special characters are not allowed";
        flag = false;
      }

      if (
        item?.value &&
        item?.name === "email" &&
        !validator.isEmail(item?.value)
      ) {
        tempInputFields[index]["error"] = "EMAIL_FORMAT_NOT_VALID_ERR";
        tempInputFields[index]["errFieldValue"] = "Email format is not valid";
        flag = false;
      }

      if (
        item?.name === "password" &&
        (item?.value?.length < 8 || item?.value?.length > 16)
      ) {
        // AlertModal("Password length must be 8 to 16 characters long", alertIconType.errorIcon, true);
        tempInputFields[index]["error"] = "PWD_8_TO_16_CHAR_LONG";
        tempInputFields[index]["errFieldValue"] =
          "Password must be 8 to 16 characters long";
        flag = false;
      }
    });

    setInputFields(tempInputFields);
    return flag;
  }

  function inputSecurityCheck() {
    const tempInputFields = [...inputFields];
    let flag = true;
    tempInputFields?.forEach((item, index) => {
      if (
        !isEmpty(item?.value) &&
        item?.name !== "termsCondition" &&
        !securityFilter(item?.value)
      ) {
        tempInputFields[index]["error"] = "SPECIAL_CHAR_NOT_ALLOWED_ERR";
        tempInputFields[index]["errFieldValue"] = "Email format is not valid";
        flag = false;
      }
    });

    setInputFields(tempInputFields);
    return flag;
  }

  function isPasswordMatched() {
    const pwd = inputFields[3]?.value;
    const confirmPwd = inputFields[4]?.value;
    const tempInputFields = [...inputFields];

    if (pwd !== confirmPwd) {
      tempInputFields[4]["error"] = "NEW_PASSWORD_PASSWORD_NOT_MATCH_ERROR";
      tempInputFields[4]["errFieldValue"] =
        "New password and confirm password not match";
      setInputFields(tempInputFields);
      return false;
    }

    return true;
  }

  function signUpApi(fullName, email, socialLoginData = null) {
    // Search for user time zone id
    setLoader(true);
    const currentZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const UserTimezoneID = timezoneIdList?.filter(
      (el, i) => el?.Name === currentZone
    )[0]?.ID;

    const payload = {
      fullName,
      email,
      countryId: inputFields[2]?.value?.toString(),
      UserTimezoneID,
      referralCode: inputFields[5]?.value?.toString(),
      phone_no: "",
      deviceType: "WEB",
      roleId: 2,
      password: encryptRequest(inputFields[3]?.value)?.content,
    };

    if (socialLoginData) {
      // delete(payload?.countryId)
      delete payload?.password;
      payload["socialLoginType"] = 1;
      payload["socialLoginId"] = socialLoginData?.socialLoginId;
    }


    signup(payload)
      .then((res) => {
        const successResponse = {
          status: "SIGNUP_SUCCESS",
          payload: {
            email: payload?.email,
            password: payload?.password,
            deviceType: "WEB",
            roleId: 2,
          },
        };

        if (payload?.socialLoginType === 1) {
          delete successResponse?.payload?.password;
          successResponse["payload"]["socialLoginType"] = 1;
          successResponse["payload"]["socialLoginId"] = payload?.socialLoginId;
        }

        dispatch(setSignUpSuccessData(successResponse));
      })
      .catch((err) => {
        AlertModal(err?.response?.data?.message, alertIconType.errorIcon, true);
      })
      .finally(() => {
        setLoader(false);
      });
  }

  function handleSignUpSubmit() {
    if (!formValidate() || !inputSecurityCheck() || !isPasswordMatched()) {
      return;
    }

    if (!validator.isStrongPassword(inputFields[3]?.value)) {
      const tempInputFields = [...inputFields];
      tempInputFields[3]["error"] = "CHANGE_PWD_WEEK_PASSWORD";
      tempInputFields[3]["errFieldValue"] =
        "Weak password. Password must contain at least 8 characters including an uppercase letter, a lowercase letter, a digit, and a special character";
      setInputFields(tempInputFields);
      return false;
    }

    const fullName = inputFields[0]?.value;
    const email = encryptRequest(inputFields[1]?.value)?.content;
    signUpApi(fullName, email, null);
  }

  useEffect(() => {
    if (socialSignInData) {
      const email = encryptRequest(socialSignInData?.email)?.content;
      const socialLoginData = {
        name: socialSignInData?.name,
        picture: socialSignInData?.picture,
      };
      if (!socialSignInData?.graphDomain) {
        /* Google SignIn */
        socialLoginData["socialLoginId"] = socialSignInData?.sub;
        socialLoginData["locale"] = socialSignInData?.locale;
      } else {
        /* Facebook SignIn */
        socialLoginData["socialLoginId"] = socialSignInData?.userID;
      }
      signUpApi(socialLoginData?.name, email, socialLoginData);
    }
  }, [socialSignInData]);

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      const { data: countryByIPAdd } = await getCountryByIp(ipAddData?.ip);

      if (countryByIPAdd) {
        const defaultCountry = countryList.find(
          (element) =>
            element?.country_code === countryByIPAdd?.location?.country
        );

        setDefaultCountry(defaultCountry);
      }
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  function handlePwdDisplayToggle(inputType, inputName) {
    const tempInputFieldData = [...inputFields];
    if (inputType === "password" && inputName === "password") {
      tempInputFieldData[3]["type"] = "text";
    } else if (inputType === "password" && inputName === "confirmPassword") {
      tempInputFieldData[4]["type"] = "text";
    } else if (inputType === "text" && inputName === "password") {
      tempInputFieldData[3]["type"] = "password";
    } else {
      tempInputFieldData[4]["type"] = "password";
    }

    setInputFields(tempInputFieldData);
  }

  function handleGotItAfterSingUpSuccessButton() {
    setLoader(true);
    login(signUpSuccessData?.payload)
      .then((res) => {
        const userData = res?.data?.result;
        const decryptedUserData = decryptRequest(userData);
        setSession("kidoProtectUser", userData);
        setSession("kidoProtectUserAccessToken", JSON.parse(decryptedUserData)?.accessToken)
        history.push("/auth/emergency-pin-code");
      })
      .catch((error) => {
        AlertModal(error.response.data.message, alertIconType.errorIcon, true);
      })
      .finally(() => {
        setLoader(false);
        dispatch(removeItem("SIGN_UP_SUCCESS"));
      });
  }

  if (signUpSuccessData?.status === "SIGNUP_SUCCESS") {
    return (
      <SignUpSuccess
        handleGotItAfterSingUpSuccessButton={
          handleGotItAfterSingUpSuccessButton
        }
        loader={loader}
      />
    );
  }

  return (
    <>
      <div className="container">
        <div className="auth-wrapper">
          <div className="auth-inner">
            <h2 className="text-center mb-3">
              {getLangTranslation("SIGNUP_TITLE", "Sign up")}
            </h2>

            {inputFields?.map((item, index) => {
              if (
                item?.type === "text" &&
                item?.name !== "password" &&
                item?.name !== "confirmPassword"
              ) {
                return (
                  <div className="mb-6" key={index}>
                    <label
                      htmlFor={item?.name}
                      className="form-label text-capitalize"
                    >
                      {getLangTranslation(item?.labelText, item?.labelValue)}
                    </label>
                    <input
                      type={item?.type}
                      className="form-control"
                      name={item?.name}
                      id={item?.name}
                      placeholder={getLangTranslation(
                        item?.placeholder,
                        item?.labelValue
                      )}
                      value={item?.value}
                      onChange={handleInputChange}
                    />
                    {item?.error && (
                      <div className="field-error">
                        {getLangTranslation(item?.error, item?.errFieldValue)}
                      </div>
                    )}
                  </div>
                );
              } else if (
                item?.type === "password" ||
                item?.name === "password" ||
                item?.name === "confirmPassword"
              ) {
                if (
                  (item?.name === "confirmPassword" &&
                    inputFields.find((item) => item.name === "password")
                      .value) ||
                  item.name === "password"
                )
                  return (
                    <div className="mb-6" key={index}>
                      <label htmlFor={item?.name} className="form-label">
                        {getLangTranslation(item?.labelText, item?.labelValue)}
                      </label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type={item?.type}
                          id={item?.name}
                          name={item?.name}
                          placeholder={getLangTranslation(
                            item?.placeholder,
                            item?.labelValue
                          )}
                          value={item?.value}
                          onChange={handleInputChange}
                        />
                        <span
                          className="input-group-text pt-cursor"
                          onClick={() =>
                            handlePwdDisplayToggle(item?.type, item?.name)
                          }
                        >
                          {item?.type === "password" ? (
                            <i
                              className="fa fa-eye-slash"
                              id="togglePassword"
                            ></i>
                          ) : (
                            <i className="fa fa-eye" id="togglePassword"></i>
                          )}
                        </span>
                      </div>
                      {item?.error && (
                        <div className="field-error">
                          {getLangTranslation(item?.error, item?.errFieldValue)}
                        </div>
                      )}
                    </div>
                  );
              } else if (item?.type === "select" && item?.id !== 'country') {
                return (
                  <div className="mb-6" key={index}>
                    <label htmlFor={item?.name} className="form-label">
                      {getLangTranslation(item?.labelText, item?.labelValue)}
                    </label>
                    <select
                      className="form-select"
                      id={item?.name}
                      name={item?.name}
                      aria-label="Default select example"
                      onChange={handleInputChange}
                      value={item?.value}
                    >
                      <option value="">
                        {getLangTranslation(item?.labelText, item?.labelValue)}
                      </option>
                      {countryList?.map((item, index) => {
                        return (
                          <option value={item?.CountryID} key={index}>
                            {item?.CountryName}
                          </option>
                        );
                      })}
                    </select>
                    {item?.error && (
                      <div className="field-error">
                        {getLangTranslation(item?.error, item?.errFieldValue)}
                      </div>
                    )}
                    {!item?.value && (
                      <label className="form-label text-gray">
                        Detecting Country...
                      </label>
                    )}
                  </div>
                );
              } else if (item?.type === "checkbox") {
                return (
                  <>
                    <div className="form-check mb-2" key={index}>
                      <input
                        className="form-check-input"
                        type={item?.type}
                        value={item?.value}
                        name={item?.name}
                        id={item?.id}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label fw-semibold"
                        htmlFor={item?.id}
                      >
                        {/* {getLangTranslation('SIGNUP_TERMS_AND_CONDITIONS', 'I agree to the Terms of Service and Privacy Policy')} */}
                        {`${getLangTranslation(
                          "PARENT_I_AGREE_TO_THE",
                          "I agree to the"
                        )} `}
                        <Link to="/terms-and-conditions" className="ms-1">
                          {getLangTranslation(
                            "SIGNUP_TERMS_AND_SERVICES",
                            "Terms of Service"
                          )}{" "}
                        </Link>
                        {getLangTranslation("SIGNUP_AND", "and")}
                        <Link to="/privacy-policy">
                          {" "}
                          {getLangTranslation(
                            "SIGNUP_PRIVACY_POLICY",
                            "Privacy Policy"
                          )}
                        </Link>
                      </label>
                    </div>
                    {item?.error && (
                      <div className="field-error mb-3">
                        {getLangTranslation(item?.error, item?.errFieldValue)}
                      </div>
                    )}
                  </>
                );
              } else if (item?.type === "accordian") {
                return (
                  <>
                    <div className="mb-6" key={index}>
                      <div className="d-flex justify-content-between">
                        <label
                          htmlFor={item?.name}
                          className="form-label text-capitalize"
                        >
                          {getLangTranslation(
                            item?.labelText,
                            item?.labelValue
                          )}
                        </label>
                        <div
                          className="c-pointer"
                          onClick={() => {
                            const temp = inputFields?.map((itm) => {
                              if (itm?.type === "accordian") {
                                return {
                                  ...itm,
                                  dropdownValue: !itm?.dropdownValue,
                                };
                              } else return itm;
                            });
                            setInputFields(temp);
                          }}
                        >
                          <i
                            className={`fa fa-angle-right down-arrow`}
                            aria-hidden="true"
                          ></i>
                        </div>
                      </div>
                      {item?.dropdownValue === true && (
                        <input
                          type={item?.type}
                          className="form-control"
                          name={item?.name}
                          id={item?.name}
                          placeholder={getLangTranslation(
                            item?.placeholder,
                            item?.placeholderValue
                          )}
                          value={item?.value}
                          onChange={handleInputChange}
                        />
                      )}
                      {item?.error && (
                        <div className="field-error">
                          {getLangTranslation(item?.error, item?.errFieldValue)}
                        </div>
                      )}
                    </div>
                  </>
                );
              }
              return null;
            })}

            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSignUpSubmit}
              >
                {!loader ? (
                  <span className="btn-upper-case text-white">
                    {getLangTranslation("SIGNUP_BTN_TEXT", "Sign up")}
                  </span>
                ) : (
                  <Loader height={20} width={100} />
                )}
              </button>
            </div>

            <p className="text-center my-6 light-text text-uppercase">
              {getLangTranslation("SIGN_UP_VIA", "Sign Up Via")}
            </p>

            <SocialLogin setSocialSignInData={setSocialSignInData} />
            <p className="text-center my-6 fw-semibold">
              {getLangTranslation(
                "SIGNUP_ALREADY_HAVE_A_ACCOUNT",
                "Already have an account?"
              )}{" "}
              <Link to="/auth/login" className="ms-1">
                {getLangTranslation("LOGIN_BTN_TEXT", "Log In")}
              </Link>
            </p>
            <AuthTermsService />
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
